<template>
  <div class="sticky bottom-2 mt-8">
    <div
      class="relative rounded-app bg-white p-2 shadow-[0_0_15px_-3px_rgba(0,0,0,0.1),0_0_6px_-4px_rgba(0,0,0,0.1)]"
    >
      <div class="flex flex-wrap gap-2">
        <div class="flex flex-1 md:mr-auto md:flex-none">
          <Button
            :content="__('Cancel')"
            type="submit"
            :disabled="isLoading"
            variation="outline"
            @click="redirectToPage('redesign.company.templates.index')"
            value="Cancel"
            class="flex-1 sm:flex-none"
          >
          </Button>
        </div>
        <Button
          :content="metadata.status ? __('Save') : actionText"
          type="submit"
          :disabled="isLoading"
          variation="fill"
          @click="updateAction('post')"
          value="Post"
          class="flex-1 sm:flex-none"
          :show-loading-spinner="true"
          :is-loading="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { reactive } from 'vue';

  import { __, redirectToPage } from '@/helpers';
  import { Icon } from '@/components/block/icon';
  import Button from '@/components/global/Button.vue';

  const props = defineProps({
    isLoading: {
      type: Boolean,
      required: true
    },
    metadata: {
      type: Object,
      required: true
    },
    actionText: {
      type: String,
      required: false,
      default: 'Save Template'
    }
  });

  const emit = defineEmits(['update:status', 'updateAction']);

  const updateAction = (val) => {
    emit('updateAction', val);
  };

  const setStatus = (val) => {
    emit('update:status', val);
  };
</script>
